<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #sidenav [mode]="isMobile ? 'over' : 'side'" [opened]="!isMobile" class="sidenav">
    <div class="nav-header">
      <div class="logo">
        <img width="100" src="assets/img/RS_White bkgrnd.svg" alt="" srcset="" />
      </div>
      <div class="language-selector-container">
        <app-language-selector></app-language-selector>
        @if (isMobile) {
          <button mat-icon-button class="close-sidenav-button" (click)="sidenav.close()">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    </div>

    <div class="search-container">
      <mat-icon class="search-icon">search</mat-icon>
      <input type="text" placeholder="Buscar" class="search-input" />
    </div>

    <div class="nav-content">
      <mat-nav-list>
        <mat-list-item
          *appHasRole="'doorman'"
          (click)="navigateTo('/doorman-dashboard'); closeSidenavIfMobile()"
          [class.active]="isActive('/doorman-dashboard')"
          class="nav-item"
        >
          <mat-icon matListItemIcon>dashboard</mat-icon>
          <span matListItemTitle>{{ i18n.get('nav.doormanDashboard') }}</span>
        </mat-list-item>
        <mat-list-item
          (click)="navigateTo('/super-admin/dashboard'); closeSidenavIfMobile()"
          [class.active]="isActive('/super-admin/dashboard')"
          class="nav-item"
        >
          <mat-icon matListItemIcon>dashboard</mat-icon>
          <span matListItemTitle>{{ i18n.get('nav.superAdminDashboard') }}</span>
        </mat-list-item>

        <mat-list-item
          (click)="navigateTo('/building-admin/dashboard'); closeSidenavIfMobile()"
          [class.active]="isActive('/building-admin/dashboard')"
          class="nav-item"
        >
          <mat-icon matListItemIcon>dashboard</mat-icon>
          <span matListItemTitle>{{ i18n.get('nav.buildingAdminDashboard') }}</span>
        </mat-list-item>

        <mat-list-item
          *appHasRole="'admin'"
          (click)="navigateTo('/buildings-list'); closeSidenavIfMobile()"
          [class.active]="isActive('/buildings-list')"
          class="nav-item"
        >
          <mat-icon matListItemIcon>apartment</mat-icon>
          <span matListItemTitle>{{ i18n.get('nav.buildings') }}</span>
        </mat-list-item>

        <mat-list-item
          sciGuaduaIsAllowed
          [identifiers]="['AgencyListView']"
          (click)="navigateTo('/agency-list'); closeSidenavIfMobile()"
          [class.active]="isActive('/agency-list')"
          class="nav-item"
        >
          <mat-icon matListItemIcon>apartment</mat-icon>
          <span matListItemTitle>Inmobiliarias</span>
        </mat-list-item>

        <mat-list-item
          *appHasRole="'admin,doorman'"
          (click)="navigateTo('/categories'); closeSidenavIfMobile()"
          [class.active]="isActive('/categories')"
          class="nav-item"
        >
          <mat-icon matListItemIcon>category</mat-icon>
          <span matListItemTitle>{{ i18n.get('nav.categories') }}</span>
        </mat-list-item>

        <mat-list-item
          *appHasRole="'admin'"
          (click)="navigateTo('/packages'); closeSidenavIfMobile()"
          [class.active]="isActive('/packages')"
          class="nav-item"
        >
          <mat-icon matListItemIcon>inventory</mat-icon>
          <span matListItemTitle>{{ i18n.get('nav.packages') }}</span>
        </mat-list-item>

        <mat-list-item
          *appHasRole="'admin,doorman'"
          (click)="navigateTo('/bookings'); closeSidenavIfMobile()"
          [class.active]="isActive('/bookings')"
          class="nav-item"
        >
          <mat-icon matListItemIcon>event_note</mat-icon>
          <span matListItemTitle>{{ i18n.get('nav.bookings') }}</span>
        </mat-list-item>

        <mat-list-item
          *appHasRole="'admin'"
          (click)="navigateTo('/vendors'); closeSidenavIfMobile()"
          [class.active]="isActive('/vendors')"
          class="nav-item"
        >
          <mat-icon matListItemIcon>business</mat-icon>
          <span matListItemTitle>{{ i18n.get('nav.vendors') }}</span>
        </mat-list-item>

        <mat-list-item
          *appHasRole="'admin,doorman'"
          (click)="navigateTo('/residents'); closeSidenavIfMobile()"
          [class.active]="isActive('/residents')"
          class="nav-item"
        >
          <mat-icon matListItemIcon>person</mat-icon>
          <span matListItemTitle>{{ i18n.get('nav.residents') }}</span>
        </mat-list-item>

        <mat-list-item
          *appHasRole="'admin'"
          (click)="navigateTo('/memberships'); closeSidenavIfMobile()"
          [class.active]="isActive('/memberships')"
          class="nav-item"
        >
          <mat-icon matListItemIcon>card_membership</mat-icon>
          <span matListItemTitle>{{ i18n.get('nav.memberships') }}</span>
        </mat-list-item>

        <mat-list-item
          *appHasRole="'admin'"
          (click)="navigateTo('/vendor-payments'); closeSidenavIfMobile()"
          [class.active]="isActive('/vendor-payments')"
          class="nav-item"
        >
          <mat-icon matListItemIcon>payments</mat-icon>
          <span matListItemTitle>{{ i18n.get('nav.vendorPayments') }}</span>
        </mat-list-item>

        <mat-list-item
          (click)="navigateTo('/auth-management'); closeSidenavIfMobile()"
          [class.active]="isActive('/auth-management')"
          class="nav-item"
        >
          <mat-icon matListItemIcon>account_circle</mat-icon>
          <span matListItemTitle>Seguridad</span>
        </mat-list-item>
        <mat-list-item
          (click)="navigateTo('/auth-management-by-building'); closeSidenavIfMobile()"
          [class.active]="isActive('/auth-management-by-building')"
          class="nav-item"
        >
          <mat-icon matListItemIcon>account_circle</mat-icon>
          <span matListItemTitle>Seguridad Administrador</span>
        </mat-list-item>
      </mat-nav-list>
      <div class="nav-footer">
        <mat-list-item
          *appHasRole="'doorman'"
          (click)="navigateTo('/doorman-profile'); closeSidenavIfMobile()"
          [class.active]="isActive('/doorman-profile')"
          class="nav-item"
        >
          <mat-icon matListItemIcon>account_circle</mat-icon>
          <span matListItemTitle>{{ i18n.get('nav.myProfile') }}</span>
        </mat-list-item>
        <mat-list-item (click)="logout()" class="nav-item logout-item">
          <mat-icon matListItemIcon>logout</mat-icon>
          <span matListItemTitle>{{ i18n.get('nav.logout') }}</span>
        </mat-list-item>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="main-content">
    @if (isMobile) {
      <button mat-icon-button class="menu-button" (click)="sidenav.toggle()">
        <mat-icon>menu</mat-icon>
      </button>
    }
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
